function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { addListener } from '@domain-group/fe-helper';
import { jsx as ___EmotionJSX } from "@emotion/core";
var breakpoints = {
  tabletMinWidth: '624px',
  desktopMinWidth: '1021px',
  largeDesktopMinWidth: '1800px'
};
class MultiResolutionResponsiveImage extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "loadImage", () => {
      if (typeof window !== 'undefined') {
        this.img = new Image();
        this.removeLoadListener = addListener(this.img, 'load', this.handleLoad);
        this.removeErrorListener = addListener(this.img, 'error', this.handleError);
        if (window.matchMedia("(max-width: ".concat(breakpoints.tabletMinWidth, ")")).matches) {
          this.img.src = this.props.images.srcSmall;
        } else if (window.matchMedia("(max-width: ".concat(breakpoints.desktopMinWidth, ")")).matches) {
          this.img.src = this.props.images.srcMedium;
        } else if (window.matchMedia("(max-width: ".concat(breakpoints.largeDesktopMinWidth, ")")).matches) {
          this.img.src = this.props.images.srcLarge;
        } else {
          this.img.src = this.props.images.srcExtraLarge;
        }
      }
    });
    _defineProperty(this, "removeListeners", () => {
      if (this.removeLoadListener) {
        this.removeLoadListener();
      }
      if (this.removeErrorListener) {
        this.removeErrorListener();
      }
    });
    _defineProperty(this, "handleLoad", () => {
      this.setState({
        srcExtraLarge: this.props.images.srcExtraLarge,
        srcLarge: this.props.images.srcLarge,
        srcMedium: this.props.images.srcMedium,
        srcSmall: this.props.images.srcSmall
      });
    });
    _defineProperty(this, "handleError", () => {
      this.setState({
        error: true
      });
    });
    _defineProperty(this, "callOnLoad", event => {
      if (event.target.src === this.props.images.srcExtraLarge || event.target.src === this.props.images.srcLarge || event.target.src === this.props.images.srcMedium || event.target.src === this.props.images.srcSmall) {
        this.props.onLoad();
      } else if (event.target.src === this.props.images.srcLowResolution) {
        this.props.onLoadLowResolution();
      }
    });
    this.state = {
      srcSmall: this.props.images.srcLowResolution || this.props.images.srcSmall,
      srcMedium: this.props.images.srcLowResolution || this.props.images.srcMedium,
      srcLarge: this.props.images.srcLowResolution || this.props.images.srcLarge,
      srcExtraLarge: this.props.images.srcLowResolution || this.props.images.srcExtraLarge,
      error: false
    };
  }
  componentDidMount() {
    this.loadImage();
  }
  componentWillUnmount() {
    this.removeListeners();
  }
  render() {
    if (this.props.fallback && this.state.error) {
      return this.props.fallback;
    }
    return ___EmotionJSX("picture", null, ___EmotionJSX("source", {
      media: "(max-width: ".concat(breakpoints.tabletMinWidth, ")"),
      srcSet: this.state.srcSmall
    }), ___EmotionJSX("source", {
      media: "(max-width: ".concat(breakpoints.desktopMinWidth, ")"),
      srcSet: this.state.srcMedium
    }), ___EmotionJSX("source", {
      media: "(max-width: ".concat(breakpoints.largeDesktopMinWidth, ")"),
      srcSet: this.state.srcLarge
    }), ___EmotionJSX("img", {
      className: this.props.className,
      src: this.state.srcExtraLarge,
      alt: this.props.alt,
      onLoad: this.callOnLoad
    }));
  }
}
MultiResolutionResponsiveImage.propTypes = {
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  images: PropTypes.object.isRequired,
  alt: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
  onLoadLowResolution: PropTypes.func,
  fallback: PropTypes.node
};
MultiResolutionResponsiveImage.defaultProps = {
  className: undefined,
  onLoad: () => {},
  onLoadLowResolution: () => {},
  fallback: undefined
};
export default MultiResolutionResponsiveImage;